import { Badge, Table } from "@chakra-ui/react";
import { GradeCriteria } from "../../../../services/Dtos";
import SettingsCard from "../../../CustomUi/SettingsCard";

interface Props {
  gradeCriteria: GradeCriteria;
  handleClick: () => void;
}

export default function GradeCriteriaCard({
  gradeCriteria,
  handleClick,
}: Props) {

  return (
    <SettingsCard minW={"270px"} handleClick={handleClick}>
      <Table.Root fontSize={"sm"} variant={"outline"}>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Grade</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              <Badge
                variant={"outline"}
                colorPalette={gradeCriteria.color || "blue"}
                size={"md"}
              >
                {gradeCriteria.grade}
              </Badge>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Min Score</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {gradeCriteria.minScore}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Max Score</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {gradeCriteria.maxScore}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Description</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {gradeCriteria.description}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Order</Table.Cell>
            <Table.Cell textAlign={"right"} fontWeight={"bold"} pl={5}>
              {gradeCriteria.order}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>
    </SettingsCard>
  );
}
